import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function SequenceBasicsPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        Ciąg to uporządkowana lista liczb. Możemy traktować go jak funkcję, której
        argumentami są dodatnie liczby naturalne: numerowi <InlineMath math="n" />
        przyporządkowujemy wyraz <InlineMath math="a_n" />.
      </p>
      <BlockMath math={String.raw`1\mapsto a_1,\quad 2\mapsto a_2,\quad 3\mapsto a_3,\ldots`} />
      <p>
        Wzór ogólny pozwala obliczyć dowolny wyraz bez liczenia poprzednich.
        We wzorze rekurencyjnym kolejny wyraz obliczamy z wyrazu lub wyrazów
        wcześniejszych, dlatego zaczynamy od podanych wartości początkowych.
      </p>
      <p>
        Symbol <InlineMath math="S_n" /> oznacza sumę pierwszych <InlineMath math="n" /> wyrazów:
      </p>
      <BlockMath math={String.raw`S_n=a_1+a_2+\ldots+a_n`} />
      <p>
        Dla dowolnego ciągu możemy po prostu policzyć potrzebne wyrazy i je dodać.
        Dla ciągu arytmetycznego i geometrycznego poznamy później krótsze wzory na
        <InlineMath math="S_n" />.
      </p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Obliczanie piątego wyrazu ze wzoru ogólnego",
      description: "Obliczamy a₅, więc we wzorze ogólnym podstawiamy n = 5.",
      content: (
        <div className="space-y-3">
          <BlockMath math="a_n=3n-2" />
          <BlockMath math={String.raw`a_5=3\cdot5-2=13`} />
        </div>
      ),
    },
    {
      label: "Przykład 2",
      summary: "Obliczanie sumy czterech początkowych wyrazów",
      description: "Obliczamy a₁, a₂, a₃ i a₄, a następnie dodajemy otrzymane liczby.",
      content: (
        <div className="space-y-3">
          <BlockMath math="a_n=2n+1" />
          <BlockMath math={String.raw`a_1=3,\quad a_2=5,\quad a_3=7,\quad a_4=9`} />
          <BlockMath math="S_4=3+5+7+9=24" />
        </div>
      ),
    },
    {
      label: "Przykład 3",
      summary: "Obliczanie drugiego i trzeciego wyrazu ciągu rekurencyjnego",
      description: "Korzystając kolejno ze wzoru rekurencyjnego, obliczamy a₂, a potem a₃.",
      content: (
        <div className="space-y-3">
          <BlockMath math={String.raw`\begin{cases}a_1=2,\\a_{n+1}=2a_n+1 & \text{dla } n\ge 1.\end{cases}`} />
          <BlockMath math={String.raw`a_2=2\cdot2+1=5`} />
          <BlockMath math={String.raw`a_3=2\cdot5+1=11`} />
        </div>
      ),
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
